import { useAct } from 'FlowBuilder/store'
import InlineCkEditor from 'Shared/components/CKEditor/InlineCkEditor'

export default function CustomActionForm({ actionId }) {
  const act = useAct()

  const action = useSel(s => s.actions.entities[s.local.selectedActionId])
  const config = action.config || { content: '' }
  const mergeTags = useSel(s => s.builder.mergeTags || [])
  const [sourceModeEnabled, setSourceModeEnabled] = useState(false)

  function update(data) {
    act.actions.upsert(actionId, { config: { ...config, ...data } })
  }

  function toggleSourceMode() {
    setSourceModeEnabled(!sourceModeEnabled)
  }

  return <div className="box narrow">
    <h2 className='no-margin-top'>Custom Step</h2>
    <div className='field'>
      <label className="bold margin-top margin-bottom half">Content:</label>
      <InlineCkEditor
        value={config.content}
        sourceMode={sourceModeEnabled}
        setSourceMode={toggleSourceMode}
        onUpdate={content => update({ content })}
        mergeTags={mergeTags}
      />
      <div className='flex field margin-top double'>
        <label className="bold">Show skip button</label>
        <input
          type='checkbox'
          checked={action.config.skipButton}
          onChange={(e) => act.actions.upsert(actionId, { config: { ...config, skipButton: e.target.checked } })}
          className="margin-left"
        />
      </div>
      {!action.config.skipButton &&
        <p className="margin-top half no-margin-bottom text-small">Without a skip button there is no way to move to the next step.</p>
      }
      {action.config.skipButton && <>
        <div className='flex column field margin-top'>
          <label className="bold">Skip button text</label>
          <input
            type='text'
            value={action.config.skipButtonText || ''}
            onChange={(e) => act.actions.upsert(actionId, { config: { ...config, skipButtonText: e.target.value } })}
            className="margin-top half"
          />
        </div>
      </>}
    </div>
  </div>
}
